import { RefTypeLink } from "../../types/Approvals";
import {
  ApprovalActionTypeMap,
  ApprovalStatusGroupType,
} from "../../types/Shared";

export const approvalStatus: ApprovalStatusGroupType = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  DELEGATED: "Delegated",
};

export const approvalAction: ApprovalActionTypeMap = {
  APPROVED: "Approve",
  REJECTED: "Reject",
  DELEGATED: "Delegate",
};

export const refTypeLinks: RefTypeLink = {
  Deliverable: "/app/dashboard/deliverables/refId",
  Task: "/app/dashboard/tasks/refId",
  Milestone: "/app/dashboard/milestones/refId",
  ProjectDrawInvoice: "/app/sherpa/projects/projectId/idms/drawId/invoice/refId",
  ProjectDrawDocument: "/app/sherpa/projects/projectId/idms/drawId/document/refId",
};
